module.exports = __webpack_public_path__ + "img/ico-link.6eb233e8.svg";